// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__1lCsY","emails":"CreateEditClinics_emails__1F-ko","emailTagLabel":"CreateEditClinics_emailTagLabel__YrR2w"};